import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getMaintenancePeriodsRepository from './getMaintenancePeriods.repository';

type InitialState = {
  loading: boolean;
  data?: any[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getMaintenancePeriods = createAsyncThunk(
  'getMaintenancePeriods',
  async (): Promise<any[]> => {
    return await getMaintenancePeriodsRepository().catch((error) => {
      throw error;
    });
  }
);

const serviceSlice = createSlice({
  name: 'maintenancePeriods',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaintenancePeriods.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getMaintenancePeriods.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getMaintenancePeriods.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
